"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _Close = _interopRequireDefault(require("@mui/icons-material/Close"));
var _ArrowBack = _interopRequireDefault(require("@mui/icons-material/ArrowBack"));
var _Dialog = _interopRequireDefault(require("@mui/material/Dialog"));
var _Text = _interopRequireDefault(require("../Text"));
var _Button = _interopRequireDefault(require("../Button"));
var _theme = require("../../theme");
var _i18n = _interopRequireDefault(require("../../localization/i18n"));
var _tokens = _interopRequireDefault(require("../../localization/tokens"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/**
 *
 * @param {*} param0
 */
var FormModal = function FormModal(_ref) {
  var open = _ref.open,
    close = _ref.close,
    title = _ref.title,
    maxWidth = _ref.maxWidth,
    fullWidth = _ref.fullWidth,
    transitionComponent = _ref.transitionComponent,
    children = _ref.children,
    _ref$disableBackdropC = _ref.disableBackdropClick,
    disableBackdropClick = _ref$disableBackdropC === void 0 ? false : _ref$disableBackdropC,
    disableEscapeKeyDown = _ref.disableEscapeKeyDown,
    onSave = _ref.onSave,
    onBack = _ref.onBack,
    saveButtonText = _ref.saveButtonText,
    _ref$showSaveButton = _ref.showSaveButton,
    showSaveButton = _ref$showSaveButton === void 0 ? true : _ref$showSaveButton,
    onRemove = _ref.onRemove,
    onReset = _ref.onReset,
    resetButtonText = _ref.resetButtonText,
    customContainerStyle = _ref.customContainerStyle,
    customFormStyle = _ref.customFormStyle,
    customTitleIconWrapperStyle = _ref.customTitleIconWrapperStyle,
    noHeader = _ref.noHeader,
    testid = _ref.testid,
    id = _ref.id,
    saveButtonStyle = _ref.saveButtonStyle,
    secondaryButtonStyle = _ref.secondaryButtonStyle,
    removeButtonText = _ref.removeButtonText;
  var styles = {
    form: {
      flex: 'auto',
      paddingLeft: 20,
      paddingRight: 20,
      paddingBottom: 0,
      paddingTop: 0,
      overflowY: 'auto',
      borderRadius: '16px'
    },
    modal: {
      overflow: 'auto',
      outline: 'none',
      padding: '40px',
      display: 'flex',
      flexDirection: 'column',
      flex: 1,
      backgroundColor: _theme.colors.surface,
      height: '100%',
      maxWidth: fullWidth ? null : '850px'
    },
    modalTopRow: {
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'wrap',
      justifyContent: 'space-between',
      alignItems: 'center'
    },
    closeModalIcon: {
      cursor: 'pointer',
      fontSize: '22px'
    },
    goBackIcon: {
      cursor: 'pointer',
      fontSize: '22px',
      marginRight: 1.25,
      lineHeight: 20
    },
    titleIconWrapper: {
      width: '100%',
      paddingBottom: '15px',
      color: _theme.colors.mainTextGrey,
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center'
    }
  };
  return /*#__PURE__*/_react["default"].createElement(_Dialog["default"], {
    maxWidth: maxWidth,
    fullWidth: fullWidth,
    onClose: disableBackdropClick ? null : function () {
      return close();
    },
    open: open,
    "aria-labelledby": title,
    TransitionComponent: transitionComponent,
    disableEscapeKeyDown: disableEscapeKeyDown,
    sx: {
      "& .MuiPaper-rounded": {
        borderRadius: "8px"
      }
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    style: _objectSpread(_objectSpread({}, styles.modal), customContainerStyle)
  }, noHeader ? null : /*#__PURE__*/_react["default"].createElement("div", {
    style: _objectSpread(_objectSpread({}, styles.titleIconWrapper), customTitleIconWrapperStyle)
  }, /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      display: 'flex',
      alignItems: 'center'
    }
  }, onBack && /*#__PURE__*/_react["default"].createElement(_ArrowBack["default"], {
    sx: styles.goBackIcon,
    onClick: onBack
  }), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    id: id || testid,
    align: "center",
    bold: true,
    large: true,
    display: "inline-block",
    margin: "0"
  }, title)), close && /*#__PURE__*/_react["default"].createElement(_Close["default"], {
    sx: styles.closeModalIcon,
    onClick: close
  })), /*#__PURE__*/_react["default"].createElement("div", {
    style: _objectSpread(_objectSpread({}, styles.form), customFormStyle)
  }, children), onReset && onSave && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      height: 1,
      width: 'calc(100%)',
      backgroundColor: '#D1D3D4'
    }
  }), /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      padding: '0 40px'
    }
  }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    onClick: onReset,
    transparent: true,
    marginTop: 2.5,
    customStyle: _objectSpread({
      width: '48%',
      fontSize: '17px'
    }, secondaryButtonStyle)
  }, resetButtonText || _i18n["default"].t(_tokens["default"].buttons.reset)), showSaveButton && /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    color: "primary",
    onClick: onSave,
    marginTop: 2.5,
    customStyle: _objectSpread({
      width: '48%',
      fontSize: '17px'
    }, saveButtonStyle)
  }, saveButtonText || _i18n["default"].t(_tokens["default"].buttons.save)))), onRemove && onSave && /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'flex-end'
    }
  }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    onClick: onRemove,
    transparent: true,
    marginTop: 3,
    sx: {
      '&:hover': {
        backgroundColor: "lightGrey"
      }
    },
    customStyle: _objectSpread({}, secondaryButtonStyle)
  }, removeButtonText || _i18n["default"].t(_tokens["default"].buttons.remove)), showSaveButton && /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    color: "primary",
    onClick: onSave,
    marginTop: 3,
    customStyle: _objectSpread({}, saveButtonStyle)
  }, saveButtonText || _i18n["default"].t(_tokens["default"].buttons.save))), !onReset && !onRemove && onSave && /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      marginRight: 20,
      marginLeft: 20
    }
  }, showSaveButton && /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    color: "primary",
    fullWidth: true,
    onClick: onSave,
    marginTop: 3,
    customStyle: _objectSpread({}, saveButtonStyle)
  }, saveButtonText || _i18n["default"].t(_tokens["default"].buttons.save)))));
};
var _default = exports["default"] = FormModal;